
export default [
  {
    path: '/admin/loan-rejections',
    name: 'loan-rejections',
    meta: { requiresAuth: true },
    component: () => import('@/pages/credit-operation/loan-rejection')
  }
]
